module.exports = __webpack_public_path__ + "img/98.92897e2a.jpg";